import React from 'react';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const paperStyle = theme => ({
    marginBottom: theme.spacing(3),

    display: 'flex',
    flexDirection: 'column',
    flexGrown: 1,

    padding: theme.spacing(2)
});

const boldStyle = theme => ({
    fontWeight: theme.typography.fontWeightMedium
});

const containerStyle = {
    display: 'flex',
    width: '100%'
}

const containerLeftStyle = theme => ({
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'column',
    marginRight: theme.spacing(1)
});

// Rendu d'une ligne de contact
const renderContact = (paramPrenom, paramNom, paramTelephone, paramEmail, paramCodePO) => {

    let prenom = '';
    if (paramPrenom !== null && paramPrenom !== undefined) {
        prenom = paramPrenom;
    }

    let nom = '';
    if (paramNom !== null && paramNom !== undefined) {
        nom = paramNom;
    }

    let telephone = '';
    if (paramTelephone !== null && paramTelephone !== undefined) {
        telephone = paramTelephone;
    }

    let email = '';
    if (paramEmail !== null && paramEmail !== undefined) {
        email = paramEmail;
    }

    let codePO = '';
    if (paramCodePO !== null && paramCodePO !== undefined) {
        codePO = paramCodePO;
    }

    if (prenom.length === 0 && nom.length === 0 && telephone.length === 0 && email.length === 0 && codePO.length === 0) {
        return (
            <Typography sx={boldStyle} gutterBottom>&nbsp;</Typography>
        );
    }
    else {
        let result = '';

        if (prenom.length > 0 || nom.length > 0) {
            if (prenom.length > 0) {

                result = prenom;
                if (nom.length > 0) {
                    result = `${result} ${nom}`;
                }

            } else {
                result = nom;
            }
        }

        if (telephone.length > 0 || email.length > 0 || codePO.length > 0) {

            if (nom.length > 0) {
                result = `${result} (`;
            }

            if (telephone.length > 0) {
                result = result + telephone;

                if (email.length > 0) {
                    result = `${result} / ${email}`;
                }

                if (codePO.length > 0) {
                    result = `${result} / ${codePO}`;
                }
            } else {
                result = result + email;

                if (email.length > 0) {
                    result = `${result} / ${codePO}`;
                }
                else {
                    result = result + codePO;
                }
            }

            if (nom.length > 0) {
                result = `${result})`;
            }
        }

        return (
            <Typography sx={boldStyle} gutterBottom>{result}</Typography>
        );
    }
}

const InfosGenerales = ({ infosGenerales }) => {

    return (
        <>
            {
                infosGenerales && <>

                    <Paper sx={paperStyle}>
                        <Typography variant="h6" gutterBottom>Contacts commerciaux</Typography>

                        <Box sx={containerStyle}>

                            <Box sx={containerLeftStyle}>
                                {infosGenerales.preneurOrdre && <Typography gutterBottom>Preneur d'ordre : </Typography>}

                                {infosGenerales.atc && <Typography gutterBottom>ATC : </Typography>}

                                {infosGenerales.atcs && <Typography gutterBottom>Sédentaire : </Typography>}

                                {infosGenerales.responsable && <Typography gutterBottom>Responsable : </Typography>}

                                {infosGenerales.manager && <Typography gutterBottom>Manager : </Typography>}

                                {infosGenerales.compta && <Typography gutterBottom>Compta : </Typography>}
                            </Box>

                            <Box>
                                {infosGenerales.preneurOrdre &&
                                    renderContact(
                                        infosGenerales.preneurOrdre.prenom,
                                        infosGenerales.preneurOrdre.nom,
                                        infosGenerales.preneurOrdre.telephone,
                                        infosGenerales.preneurOrdre.email,
                                        infosGenerales.preneurOrdre.codePO)
                                }

                                {infosGenerales.atc &&
                                    renderContact(
                                        infosGenerales.atc.prenom,
                                        infosGenerales.atc.nom,
                                        infosGenerales.atc.telephone,
                                        infosGenerales.atc.email,
                                        '')
                                }

                                {infosGenerales.atcs &&
                                    renderContact(
                                        infosGenerales.atcs.prenom,
                                        infosGenerales.atcs.nom,
                                        infosGenerales.atcs.telephone,
                                        infosGenerales.atcs.email,
                                        infosGenerales.atcs.codePO)
                                }

                                {infosGenerales.responsable &&
                                    renderContact(
                                        infosGenerales.responsable.prenom,
                                        infosGenerales.responsable.nom,
                                        infosGenerales.responsable.telephone,
                                        infosGenerales.responsable.email,
                                        '')
                                }

                                {infosGenerales.manager &&
                                    renderContact(
                                        infosGenerales.manager.prenom,
                                        infosGenerales.manager.nom,
                                        infosGenerales.manager.telephone,
                                        infosGenerales.manager.email,
                                        '')
                                }

                                {infosGenerales.compta &&
                                    renderContact(
                                        infosGenerales.compta.prenom,
                                        infosGenerales.compta.nom,
                                        infosGenerales.compta.telephone,
                                        infosGenerales.compta.email,
                                        '')
                                }
                            </Box>
                        </Box>
                    </Paper>
                </>
            }
        </>
    );
}

export default InfosGenerales;